import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, CheckCircle2 } from 'lucide-react';
const results = [{
  day: 'Día 1-2',
  text: 'Vas a entender por qué reaccionás como reaccionás y qué busca tu ex con cada mensaje.'
}, {
  day: 'Día 3-4',
  text: 'Vas a tener un sistema claro para clasificar cada mensaje y saber cuáles merecen respuesta.'
}, {
  day: 'Día 5-6',
  text: 'Vas a responder con fórmulas probadas que cortan el conflicto sin escalar.'
}, {
  day: 'Día 7',
  text: 'Vas a notar que el tono de las conversaciones empieza a cambiar. Menos drama, más logística.'
}];
export function ResultsSection() {
  return <section className="bg-slate-50 py-24 px-6 border-y border-slate-200" data-id="element-208">
      <div className="max-w-3xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-210">
          <div className="inline-flex items-center justify-center bg-green-100 text-green-800 p-3 rounded-full mb-6" data-id="element-211">
            <Calendar size={28} data-id="element-212" />
          </div>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-213">
            Qué vas a lograr en los primeros 7 días
          </h2>
          <p className="text-lg text-slate-600 max-w-xl mx-auto" data-id="element-214">
            Resultados concretos y realistas aplicando los protocolos del
            manual.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-215">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-216">
              <div className="bg-slate-900 text-white font-bold px-4 py-2 rounded-lg whitespace-nowrap" data-id="element-217">
                {result.day}
              </div>
              <p className="text-slate-700 text-lg font-medium" data-id="element-218">
                {result.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-219">
          <a href="#offer" onClick={e => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-red-600/30 transition-all transform hover:scale-105 active:scale-95 w-full sm:w-auto" data-id="element-220">
            QUIERO EL MANUAL (PDF)
          </a>
        </motion.div>
      </div>
    </section>;
}